export const heroImage =
  'https://cdn.magicpatterns.com/uploads/iEfgCV8XzB9HbPafbTmxsn/tutu.webp'

/** Live checkout link. */
export const checkoutUrl =
  'https://the-art-flow-archive.impultienda.ar/checkout'
export const price = '$27.00'
export const regularPrice = '$137.00'
export const bonusStackTotal = '$85.00'

export const heroBadges: string[] = [
  '6 Complete Master Volumes',
  '150+ Ready-to-Teach Lessons',
  '365-Day Visual System',
  '6 Premium PDF Bonuses',
  'Instant Digital Access',
]

export const finalBadges: string[] = [
  '7-day money-back guarantee',
  'Instant access',
  'Pay once, use forever',
]

/** The Sunday-night scene, told in three short beats. */
export const sundayBeats: string[] = [
  'Searching for activities that actually work together.',
  'Rebuilding a progression from zero.',
  'Hunting for visual references, one tab at a time.',
]

/** What planning from scratch actually costs you. */
export const realCosts: Array<{ label: string; detail: string }> = [
  { label: 'Your weekends', detail: 'Planning instead of resting.' },
  { label: 'Repetition', detail: 'The same projects, on loop.' },
  { label: 'Confidence', detail: 'Improvising in front of the room.' },
  { label: 'Mixed levels', detail: 'No organized alternatives.' },
  { label: 'Assessment', detail: 'Grading taste, not progress.' },
  { label: 'Last minutes', detail: 'Scrambling when a lesson falls flat.' },
]

/** Everything included, as listed in the offer section. */
export const included: string[] = [
  '6 Complete Master Volumes',
  '150+ Ready-to-Teach Lessons',
  '365-Day Visual System',
  '100+ Visual References',
  '6 Strategic PDF Bonuses',
  'Instant Digital Access',
]

/** The closing "no more" list. */
export const noMore: string[] = [
  'No more Sunday nights searching for activities that flow',
  'No more rushed or improvised classes',
  'No more repeating the same projects',
  'No more lost weekends on planning instead of living',
  'No more entering class wishing you’d prepared more',
  'No more chaos with mixed-level groups',
  'No more guessing how to assess creative progress',
]
